import { createContext, useContext } from 'react'

export const CommonContext = createContext()

export const useCommonContext = () => {
  const context = useContext(CommonContext)
  return context || {}
}

export const CommonProvider = CommonContext.Provider
export const CommonConsumer = CommonContext.Consumer
